import Validator from "validatorjs";

export default function validateAddress(address, translator, requiresVat = false) {

    if (!address) {
        address = {}
    }

    let rules = {
        name: "required|min:3",
        street: "required",
        city: "required",
        zip: "required",
        countryCode: "required"
    }

    if (address.countryCode == 'ES' && requiresVat) {
        rules['vatId'] = "required"
    }


    let data = {
        name: address.name,
        street: address.street,
        city: address.city,
        zip: address.zip,
        countryCode: address.countryCode,
        vatId: address.vatId
    }


    let validation = new Validator(data, rules);
    validation.setAttributeNames({
        name: translator("address-input-name-label"),
        street: translator("address-input-street-label"),
        city: translator("address-input-city-label"),
        zip: translator("address-input-zip-label"),
        countryCode: translator("address-input-country-label"),
        vatId: translator("address-input-vat-id-label")
    });


    if (validation.fails()) {
        return {
            passed: false,
            errors: validation.errors.errors
        }
    }
    return { passed: true, errors: null }

}

